export function replaceNullsWithEmpty<T extends Record<string, any>>(obj: T): T {
  const recursiveReplace = (currentObj: any): any => {
    return Object.entries(currentObj).reduce((acc, [key, value]) => {
      if (value === null) {
        acc[key] = ''; // Replace null with empty string
      } else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        acc[key] = recursiveReplace(value); // Recursively handle nested objects
      } else {
        acc[key] = value; // Copy value if it's not an object or if it's an array
      }
      return acc;
    }, {} as Record<string, any>);
  };

  return recursiveReplace(obj);
}

export const isDev = import.meta.env.REACT_APP_ENV !== 'production';
